import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngxs/router-plugin';
import { Injectable } from '@angular/core';

export interface RouterStateParams {
  url: string;
  params: Params;
  queryParams: Params;
}
@Injectable()
export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateParams> {
  serialize(routerState: RouterStateSnapshot): RouterStateParams {
    const {
      url,
      root: { queryParams },
    } = routerState;

    let { root: route } = routerState;
    let params = route.params;
    while (route.firstChild) {
      route = route.firstChild;
      params = { ...params, ...route.params };
    }

    return { url, params, queryParams };
  }
}
